import React from "react";
import {
  Box,
  Card,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Divider
} from "@mui/material";

const cellBorder = "1px solid #dcdcdc";
const labelStyle = { fontWeight: 600 };
const sectionHeader = {
  backgroundColor: "#f5f7fa",
  fontWeight: 700
};

const AssessmentSummary = ({ data }) => {
  if (!data) return null;

  return (
    <Box sx={{ mb: 4 }}>
      <Card elevation={3}>
        {/* HEADER */}
        <Box
          sx={{
            textAlign: "center",
            py: 2,
            background:
              "linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)",
            color: "#fff"
          }}
        >
          <Typography variant="h5" fontWeight={700}>
            SUMMARY OF THE ASSESSMENT
          </Typography>
        </Box>

        <TableContainer component={Paper}>
          <Table size="small">
            <TableBody>
              {/* LAB NAME */}
              <TableRow>
                <TableCell colSpan={2} sx={{ border: cellBorder, ...labelStyle }}>
                  {data.lblNAF6LabName || "Laboratory Assessed"}
                </TableCell>
                <TableCell colSpan={3} sx={{ border: cellBorder }}>
                  {data.lblNaf6Lab}
                </TableCell>
              </TableRow>

              {/* QM + DATE */}
              <TableRow sx={{ backgroundColor: "#fafafa" }}>
                <TableCell colSpan={2} sx={{ border: cellBorder }}>
                  <strong>Quality Manager:</strong> {data.lblNaf6QM}
                </TableCell>
                <TableCell sx={{ border: cellBorder }}>
                  <strong>Date(s) of Visit:</strong> {data.lblNaf6Date}
                </TableCell>
                <TableCell colSpan={2} sx={{ border: cellBorder }}>
                  <strong>Corrective Action Submission Date:</strong>{" "}
                  {data.lblsubmissionDate}
                </TableCell>
              </TableRow>

              {/* TYPE */}
              <TableRow>
                <TableCell colSpan={5} sx={{ border: cellBorder }}>
                  <strong>Type of Visit:</strong>{" "}
                  {data.lblNaf6AssessmenttYPE}
                </TableCell>
              </TableRow>

              {/* FIELD / DISCIPLINE */}
              <TableRow sx={{ backgroundColor: "#fafafa" }}>
                <TableCell colSpan={2} sx={{ border: cellBorder }}>
                  <strong>Field:</strong> {data.lblNaf6field}
                </TableCell>
                <TableCell colSpan={3} sx={{ border: cellBorder }}>
                  <strong>Discipline(s):</strong> {data.lblNaf6Discipline}
                </TableCell>
              </TableRow>

              {/* FACILITY */}
              <TableRow>
                <TableCell colSpan={5} sx={{ border: cellBorder }}>
                  <strong>Facility(s):</strong> {data.lblNaf6Fcility}
                </TableCell>
              </TableRow>

              {/* LEAD ASSESSOR */}
              <TableRow sx={{ backgroundColor: "#fafafa" }}>
                <TableCell colSpan={5} sx={{ border: cellBorder }}>
                  <strong>Lead Assessor:</strong> {data.lblNaf6LA}
                </TableCell>
              </TableRow>

              {/* ASSESSMENT TEAM */}
              {data.rptrNaf6?.map((assessor, i) => (
                <TableRow key={i}>
                  <TableCell
                    colSpan={2}
                    align="center"
                    sx={{ border: cellBorder, fontWeight: 600 }}
                  >
                    {assessor.Capacity}
                  </TableCell>
                  <TableCell colSpan={3} sx={{ border: cellBorder }}>
                    {assessor.Name}
                  </TableCell>
                </TableRow>
              ))}

              {/* SUMMARY */}
              <TableRow sx={sectionHeader}>
                <TableCell colSpan={5} sx={{ border: cellBorder }}>
                  ASSESSMENT SUMMARY
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell colSpan={5} sx={{ border: cellBorder }}>
                  {data.lblNaf6AssmtSmry}
                </TableCell>
              </TableRow>

              {/* COMPLIANCE */}
              <TableRow sx={sectionHeader}>
                <TableCell colSpan={5} sx={{ border: cellBorder }}>
                  Assessment Team Comment on Compliance
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell colSpan={5} sx={{ border: cellBorder }}>
                  <ul style={{ margin: 0, paddingLeft: 18 }}>
                    <li>NABL 133: {data.lblNaf6NABL133}</li>
                    <li>NABL 142: {data.lblNaf6Nabl142}</li>
                    <li>NABL 163: {data.lblNaf6Nabl163}</li>
                    {data.linbl143 && (
                      <li>NABL 143: {data.lblNaf6Nabl143}</li>
                    )}
                  </ul>
                </TableCell>
              </TableRow>

              {/* RECOMMENDATION */}
              <TableRow sx={sectionHeader}>
                <TableCell colSpan={5} sx={{ border: cellBorder }}>
                  Recommendations of Assessment Team
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell colSpan={5} sx={{ border: cellBorder }}>
                  {data.lblNaf6Recommend}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Card>

      <Divider sx={{ my: 3 }} />
    </Box>
  );
};

export default AssessmentSummary;
